import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';
import createMetadataAPITypes from '../../utils/api-metadata-types';

const options = {
  name: 'workingTimeDirectiveReports',
  baseType: 'WORKING_TIME_DIRECTIVE_REPORTS',
  apiEndpoint: 'groups/{id}/working_time_directive_report',
  skipByIdUpdate: true // we will manually update the byID state below
};

const operations = createMetadataAPIOperations(options);
const types = createMetadataAPITypes(options);

export { operations, selectors };

const defaultReducer = createMetadataAPIReducer(options);

// Extend the default reducer to make sure that whenever a report is fetched,
// the user reports are added to the byId field, and the rules to a separate
// entry in the state. This is needed when paginating a report: the
// user_reports within each group are paginated, but the rules are not
export default (state, action) => {
  state = defaultReducer(state, action);
  if (action.type !== types.SUCCESS) return state;

  const { data } = action.payload;
  const { report_start_time, report_end_time } = data;

  const equalReportingTimes =
    state.report_start_time === report_start_time && state.report_end_time === report_end_time;

  let { byId } = state;
  // throw out all reports if reporting times changed to refresh the intervals,
  // and ensure that all reports have the same interval times. If we keep the
  // results, users who are not a member during the reporting period will stay
  // in redux, resulting in different reporting periods in the UI
  if (!equalReportingTimes) byId = {};

  for (const r of data.user_reports) {
    byId = { ...byId, [r.user.id]: r };
  }

  let rulesById = state.rulesById || {};
  for (const r of data.rules) {
    rulesById = { ...rulesById, [r.id]: r };
  }

  return { ...state, byId, rulesById, report_start_time, report_end_time };
};
